import { useRecoilState } from 'recoil'
import { useEffect } from 'react'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import projectCheckpointInstancesAtom from '../projectCheckpointInstances.atom'
import projectsApi from 'screens/Projects/projects.api'
import { IProject } from 'screens/Projects/projects.types'

export const useProjectCheckpointInstances = (
  projectId: IProject['id'] | undefined, 
  teamId: number | undefined
) => {
  const [state, setState] = useRecoilState(projectCheckpointInstancesAtom)
  const { wait, loading } = useHttpLoader()

  const instances = projectId ? state.items[projectId] || [] : []

  useEffect(() => {
    if (!projectId || state.items[projectId]) {
      return
    }

    wait(projectsApi.getProjectCheckpointInstances(projectId, teamId), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({
          ...prev,
          items: {
            ...prev.items,
            [projectId]: resp.body,
          },
        }))
      }
    })
  }, [projectId])

  const refresh = () => {
    if (!projectId) return

    wait(projectsApi.getProjectCheckpointInstances(projectId, teamId), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({
          ...prev,
          items: {
            ...prev.items,
            [projectId]: resp.body,
          },
        }))
      }
    })
  }

  return { instances, loading, refresh }
}
